import { render, staticRenderFns } from "./OnTheRoadReiter.vue?vue&type=template&id=95727cc0&"
import script from "./OnTheRoadReiter.vue?vue&type=script&lang=js&"
export * from "./OnTheRoadReiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports